// extracted by mini-css-extract-plugin
export default {"TextArea":"TextArea_TextArea__TV-j3"};